export const acquiredDefault = {
  inHouse: "In-House Acquired",
  externally: "Present on Admission",
  IHA: "IHA",
  POA: "PoA",
  PIHAw: "PIHA-w",
  IHAw: "IHA-w",
  unknown: "Not Set"
};
